import HeaderPresenter from "@adapters/presenters/header";
import FooterPresenter from "@adapters/presenters/footer";
import HomePresenter from "@adapters/presenters/home";
import CommonPresenter from "@adapters/presenters/common/Common";
import LiveNewsPresenter from "@adapters/features/LiveNews/Presenters/LiveNews";
export default (function (useCases, actions) {
    return {
        header: new HeaderPresenter(useCases.header, useCases.quoteStream, actions.header),
        home: new HomePresenter(useCases.home, useCases.shareWebinar, useCases.registrationWebinar, useCases.feedback, actions.home),
        footer: new FooterPresenter(useCases.footer, useCases.quoteStream, actions.footer),
        common: new CommonPresenter(useCases.common, actions.common, useCases.quoteStream),
        liveNews: new LiveNewsPresenter(actions.liveNews, useCases.liveNews, useCases.quoteStream, useCases.newsStream),
    };
});
